import {prependRoot} from "../util/prependRoot.js";
import {getApiRoot} from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/aanvraag/";

const AanvraagApi = {
	get(aanvraagId) {
		const serviceUrl = prependRoot(routePrefix + aanvraagId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	getFromSimulatie(simulatieId){
		const serviceUrl = prependRoot(routePrefix + 'simulatie/' + simulatieId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	loadEmptyAanvraag(typeId) {
		const serviceUrl = prependRoot(routePrefix + 'empty/' + typeId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	loadEmptyAanvrager() {
		const serviceUrl = prependRoot(routePrefix + 'aanvrager', getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	loadEmptyMandataris(accountId) {
		const serviceUrl = prependRoot(routePrefix + 'mandataris/' + accountId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			header: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(aanvraag) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(serviceUrl, aanvraag, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	loadEmptyRenovatie() {
		const serviceUrl = prependRoot(routePrefix + 'emptyRenovatie', getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default AanvraagApi;
